<template>
  <q-modal v-model="opened" name="previewModal" content-classes="default-modal width-md">
    <q-modal-layout>
      <q-toolbar slot="header" color="white" text-color="grey-9">
       <q-toolbar-title>{{ $t('preview') }}</q-toolbar-title>
        <q-btn @click="opened = false" flat dense>
          <q-icon name="close" color="grey-8"/>
        </q-btn>
      </q-toolbar>
      <div v-if="supportsInlinePDF" ref="pdfPreview" style="height: 70vh"></div>
      <div v-else class="layout-padding">
        <p class="text-center">
          {{ $t('pdf_inline_not_supported') }}
        </p>
        <div class="flex items-center justify-center">
          <q-btn color="primary" @click="handlePDFDownload">{{ $t('download') }}</q-btn>
        </div>
      </div>
    </q-modal-layout>
  </q-modal>
</template>

<script>
  import DefaultModal from 'components/Modal/DefaultModal.vue'
  import FileSaver from 'file-saver'
  import PDFObject from 'pdfobject'

  export default {
    components: {
      DefaultModal
    },
    props: ['blob'],
    data () {
      return {
        opened: false,
        fileUrl: null
      }
    },
    computed: {
      supportsInlinePDF () {
        return PDFObject.supportsPDFs
      }
    },
    methods: {
      open () {
        this.opened = true
      },
      close () {
        this.opened = false
      },
      handlePDFDownload () {
        FileSaver.saveAs(this.blob, `${this.$t('preview')}.pdf`)
      }
    },
    watch: {
      blob (blob) {
        const fileReader = new FileReader()
        fileReader.onload = (event) => {
          this.fileUrl = event.target.result

          if (this.supportsInlinePDF) {
            PDFObject.embed(this.fileUrl, this.$refs.pdfPreview, {
              fallbackLink: false
            })
          }
        }
        fileReader.readAsDataURL(blob)
      }
    }
  }
</script>
